<template>
  <tooltip text="Download">
    <button
      type="button"
      class="download-btn btn-link"
      :aria-label="`Download ${fileName}`"
      @click="download">
      <i class="fa fa-download" aria-hidden="true"></i>
    </button>
  </tooltip>
</template>

<script>
import { Tooltip } from 'uiv'

export default {
  name: 'FileDownloadButton',
  components: { Tooltip },
  props: {
    url: {
      type: String,
      required: true
    },
    fileName: {
      type: String,
      default: 'file'
    }
  },
  methods: {
    download() {
      window.open(this.url, '_blank', 'noopener,noreferrer')
    }
  }
}
</script>

<style scoped>
@import '../../styles/foundations.css';

.download-btn {
  font-size: 12px;
  padding: 2px 4px;
  line-height: 1;
  background-color: var(--blue-500);
  color: white;
  border: 1px solid var(--blue-600);
  border-radius: 4px;
  margin-left: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  /* Extend the clickable area without affecting visual size */
  position: relative;
}

.download-btn::after {
  content: '';
  position: absolute;
  inset: -6px;
}

.download-btn:hover {
  border: 1px solid var(--blue-900);
  background-color: var(--blue-900);
}

.download-btn:focus-visible {
  outline: 2px solid var(--blue-500);
  outline-offset: 3px;
}
</style>
